
<!-- 
<app-header></app-header>
<router-outlet (activate)="onActivate($event)">
</router-outlet>
<app-modal></app-modal>
<app-footer></app-footer> -->

<div style="min-height: 100vh;position: relative;">
    <app-header></app-header>
    <router-outlet (activate)="onActivate($event)">
    </router-outlet>
    <app-modal></app-modal>
</div>
<app-footer></app-footer>